import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, TextField, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import axios from 'axios';
import jwt from 'jsonwebtoken';

import { setCurrentUser } from 'actions';
import LeftQuoteView from './LeftQuoteView';

const schema = {
	email: {
		presence: { allowEmpty: false, message: 'is required' },
		email: true,
		length: {
			maximum: 64,
		},
	},
	password: {
		presence: { allowEmpty: false, message: 'is required' },
		length: {
			maximum: 128,
		},
	},
};

const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.background.default,
		height: '100%',
	},
	grid: {
		height: '100%',
	},
	contentContainer: {},
	content: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	contentHeader: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: theme.spacing(5),
		paddingBototm: theme.spacing(2),
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
	},
	logoImage: {
		marginLeft: theme.spacing(4),
	},
	contentBody: {
		flexGrow: 1,
		display: 'flex',
		alignItems: 'center',
		[theme.breakpoints.down('md')]: {
			justifyContent: 'center',
		},
	},
	form: {
		paddingLeft: 100,
		paddingRight: 100,
		paddingBottom: 125,
		flexBasis: 700,
		[theme.breakpoints.down('sm')]: {
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
		},
	},
	title: {
		marginTop: theme.spacing(3),
	},
	socialButtons: {
		marginTop: theme.spacing(3),
	},
	socialIcon: {
		marginRight: theme.spacing(1),
	},
	sugestion: {
		marginTop: theme.spacing(2),
	},
	textField: {
		marginTop: theme.spacing(2),
	},
	signInButton: {
		margin: theme.spacing(2, 0),
	},
}));

const SignIn = props => {
	const { auth, history } = props;

	const classes = useStyles();

	const [formState, setFormState] = useState({
		values: {},
		touched: {},
		errors: {},
		errorMessage: '',
	});

	useEffect(() => {
		if (auth.isAuthenticated === true) {
			history.push('/products');
		}
		const errors = validate(formState.values, schema);
		setFormState(formState => {
			return {
				...formState,
				isValid: errors ? false : true,
				errors: errors || {},
			};
		});
	}, [formState.values, auth, history]);

	const handleChange = event => {
		event.persist();

		setFormState(formState => ({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		}));
	};

	const handleSignIn = event => {
		event.preventDefault();

		axios
			.post('/api/managers/login', formState.values)
			.then(res => {
				props.setCurrentUser(jwt.verify(res.data.data, 'KETPETCARROTTECH'));
			})
			.catch(err => {
				console.log("post('/api/managers/login')", err);
				setFormState(formState => {
					return {
						...formState,
						isValid: false,
						errorMessage:
							err &&
							err.response &&
							err.response.data &&
							err.response.data.message,
					};
				});
			});
	};

	const hasError = field =>
		formState.touched[field] && formState.errors[field] ? true : false;

	return (
		<div className={classes.root}>
			<Grid className={classes.grid} container>
				<Grid className={classes.quoteContainer} item lg={5}>
					<LeftQuoteView />
				</Grid>
				<Grid className={classes.content} item lg={7} xs={12}>
					<div className={classes.content}>
						<div className={classes.contentBody}>
							<form className={classes.form} onSubmit={handleSignIn}>
								<Typography className={classes.title} variant='h2'>
									登陆
								</Typography>
								<Typography color='textSecondary' gutterBottom>
									请使用账号密码登陆
								</Typography>
								<TextField
									className={classes.textField}
									error={hasError('email')}
									fullWidth
									helperText={
										hasError('email') ? formState.errors.email[0] : null
									}
									label='邮箱'
									name='email'
									onChange={handleChange}
									type='text'
									value={formState.values.email || ''}
									variant='outlined'
								/>
								<TextField
									className={classes.textField}
									error={hasError('password')}
									fullWidth
									helperText={
										hasError('password') ? formState.errors.password[0] : null
									}
									label='密码'
									name='password'
									onChange={handleChange}
									type='password'
									value={formState.values.password || ''}
									variant='outlined'
								/>

								<Typography color='error' gutterBottom>
									{`${formState.errorMessage}`}
								</Typography>
								<Button
									className={classes.signInButton}
									color='primary'
									disabled={!formState.isValid}
									fullWidth
									size='large'
									type='submit'
									variant='contained'
								>
									点击登陆
								</Button>
							</form>
						</div>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

SignIn.propTypes = {
	history: PropTypes.object,
};

const mapStateToProps = ({ auth }) => {
	return { auth };
};

export default connect(mapStateToProps, { setCurrentUser })(withRouter(SignIn));
